// extracted by mini-css-extract-plugin
export default {"root":"TermsAndConditions_root__RKm5m"};